import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/marc-tuckmantel.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of Marc Tuckmantel"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Marc Tuckmantel"),
  /*#__PURE__*/_createElementVNode("h3", null, "Head of Product Development"),
  /*#__PURE__*/_createElementVNode("p", null, "Marc joined us from Goldman Sachs, where he worked on the equity derivatives desk in London. Marc was responsible for extending tools for risk management of flow products, implemented pricing models and developed proprietary algorithmic indices based on trading strategies for clients of the equity exotics desk. Before he joined Goldman Sachs, Marc worked as a doctoral researcher in CERN, conducting research into elementary particle physics and superstring theory.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}